import React,{useEffect,useState} from 'react'
import Slider from 'react-slick';
import iim from "../../Assets/images/iim.png"
import matrix from "../../Assets/images/matrixLogo.jpeg"
import admitcard from "../../Assets/images/admitcardLogo.png"
import hr from "../../Assets/images/h&rLogo.jpeg"
import pinelabs from "../../Assets/images/pinelabsLogo.jpg"
import vegrow from "../../Assets/images/vegrowLogo.png"
import policybazaar from "../../Assets/images/policybazaarLogo.png"
import karthikeyan from "../../Assets/images/karthikeyan.jpg"
import rachit from "../../Assets/images/admitcardRepresentative.jpeg"
import kapil from "../../Assets/images/matrixRepresentative.jpeg"
import niladri from "../../Assets/images/h&rRepresentative.webp"
import sameer from "../../Assets/images/pinelabsRepresentative.jpeg"
import divyesh from "../../Assets/images/vegrowRepresentative.jpg"
import sandeep from "../../Assets/images/policybazaarRepresentative.webp"

const TrustedBy = () => {
          const [isMobile, setIsMobile] = useState(false);
        const [mounted, setMounted] = useState(false);
            useEffect(() => {
            setIsMobile(window.innerWidth <= 768);
            setMounted(true);
            
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        }, []);
  const sliderSettings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
            breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          dots: false,
        }
      }
    ]
  };
 
  return (
    <>
    <section className='section-top-padding'>
        <div className='container'>
            <h2 className='heading-title mb-4'>
                Trusted by Recruiters & Colleges Alike
            </h2>
            <div className="mutual-card-slider slider">
                <Slider {...sliderSettings} key={isMobile ? 'mobile' : 'desktop'} className='testimonial-slider'>
                   
                      <div className='shadow-box testimonial-card'>
                          <img src={iim} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={karthikeyan} alt='' />
                            <h2>
                              Karthikeyan Balakumar
                              <span>Chairperson Placement Committee, IIM Sirmaur</span>
                            </h2>
                          </div>
                            <p>They’ve been a true catalyst in enhancing our placements, learning outcomes, and admissions. Their innovation, ownership, and proactive approach across training, placements, and digital solutions have redefined excellence. Our partnership has been truly transformative.</p>
                      </div>
                      <div className='shadow-box testimonial-card'>
                          <img src={policybazaar} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={sandeep} alt='' />
                            <h2>
                               Sandeep
                              <span>Deputy Director, PolicyBazaar</span>
                            </h2>
                          </div>
                            <p>Video profiles of students are helpful to identify promising students who may not have stellar resume. It makes hiring FAST & EFFICIENT.</p>
                      </div>
                      <div className='shadow-box testimonial-card'>
                          <img src={vegrow} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={divyesh} alt='' />
                            <h2>
                               Divyesh Sharma
                              <span>Head Global Trade, VeGrow Dubai</span>
                            </h2>
                          </div>
                            <p>Helps us compare students across multiple campuses easily & hire the best guy while keeping interviews manageable.</p>
                      </div>
                      <div className='shadow-box testimonial-card'>
                          <img src={pinelabs} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={sameer} alt='' />
                            <h2>
                              Sameer
                              <span>Vice President, Pine Labs</span>
                            </h2>
                          </div>
                            <p>Powerful way of hiring. More ease. Less interviews.</p>
                      </div>
                      <div className='shadow-box testimonial-card'>
                          <img src={hr} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={niladri} alt='' />
                            <h2>
                              Niladri Bhattacharyya
                              <span>Ex-Sr. Project Manager, H&R</span>
                            </h2>
                          </div>
                            <p>Our study abroad students were able to easily secure virtual internships in their preferred domain of choice through the platform. It was immensely helpful.</p>
                      </div>
                      <div className='shadow-box testimonial-card'>
                          <img src={admitcard} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={rachit} alt='' />
                            <h2>
                              Rachit Agarwal
                              <span>CEO, Admitkard</span>
                            </h2>
                          </div>
                            <p>We have been using masterNAUKRI platform by KidEx for the last 2 years for Fresher hiring. It has helped us easily identify relevant candidates & reduce number of interviews to take to close any position.</p>
                      </div>
                      <div className='shadow-box testimonial-card'>
                          <img src={matrix} alt='' />
                          <div className='testimonial-user-main'>
                            <img src={kapil} alt='' />
                            <h2>
                              Kapil Singh Dhaka
                              <span>CEO, Matrix Education</span>
                            </h2>
                          </div>
                            <p>It's a good place to easily find LIVE database of students seeking entry positions (full time / part time). Videos help screen candidates better.</p>
                      </div>
                   


                </Slider>
            </div>
        </div>
      </section>
    </>
  )
}

export default TrustedBy